var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinHistorySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5227 2 22 6.47733 22 12C22 17.5227 17.5227 22 12 22C6.47733 22 2 17.5227 2 12C2 6.47733 6.47733 2 12 2ZM12 4.22266C7.70444 4.22266 4.22266 7.70444 4.22266 12C4.22266 16.2956 7.70444 19.7773 12 19.7773C16.2956 19.7773 19.7773 16.2956 19.7773 12C19.7773 7.70444 16.2956 4.22266 12 4.22266ZM12 5.55566C15.559 5.55569 18.4442 8.44105 18.4443 12C18.4443 15.5591 15.5591 18.4443 12 18.4443C8.44094 18.4443 5.55566 15.5591 5.55566 12C5.55584 8.44107 8.44105 5.55572 12 5.55566ZM13.7773 8.9209C13.3523 8.67568 12.809 8.8213 12.5635 9.24609L11.6748 10.7861L10.1348 9.89648C9.70985 9.65132 9.16648 9.79706 8.9209 10.2217C8.67557 10.6467 8.82119 11.19 9.24609 11.4355L10.7861 12.3252L9.90625 13.8486C9.90314 13.8537 9.89949 13.8591 9.89648 13.8643C9.65124 14.2893 9.79765 14.8327 10.2227 15.0781C10.6213 15.3081 11.1233 15.1946 11.3867 14.8291L11.4365 14.7529L12.3252 13.2139L13.8652 14.1025L13.9463 14.1455C14.3571 14.3297 14.8491 14.1757 15.0791 13.7773C15.3088 13.3789 15.1952 12.8767 14.8301 12.6133L14.7539 12.5635L13.2139 11.6748L14.1025 10.1348C14.3477 9.70969 14.2023 9.16631 13.7773 8.9209Z",
    fill: "url(#paint0_linear_39_28287)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_28287",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinHistorySvg);
export default __webpack_public_path__ + "static/media/spin-history-svg.cc62bcc06ef6a215e5d403a8f28920e1.svg";
export { ForwardRef as ReactComponent };